export default "__VITE_ASSET__DuAqwIWy__";